export const removeChar = function (event: Event) {
    event = event || window.event;
    var keyID = (event as any).which ? (event as any).which : (event as any).keyCode;
    if (keyID == 8 || keyID == 46 || keyID == 37 || keyID == 39) {
        return;
    } else {
        (event.target as any).value = (event.target as any).value.replace(/[^-\.0-9]/g, '');
    }
}

export const comma = function (obj: string | number) {
    if (typeof obj == typeof 0) {
        obj = obj.toString();
    }

    var regx = new RegExp(/(-?\d+)(\d{3})/);
    var bExists = (obj as string).indexOf('.', 0);
    var strArr = (obj as string).split('.');

    while (regx.test(strArr[0])) {
        strArr[0] = strArr[0].replace(regx, '$1,$2'); 
    }

    if (bExists > -1) {
        obj = strArr[0] + '.' + strArr[1];
    } else {
        obj = strArr[0];
    }
    return obj;
}

export const unComma = function(value: string){
    return value.replace(/[^\d]+/g, '');
}

/**
 * 명시된 자리수의 숫자 조정하기
 *
 * @param {"round" | "floor" | "ceil"} type 조정의 유형.
 * @param {number} value 숫자 값.
 * @param {number} exp 지수(조정 기준의 10 로그)입니다.
 * @returns {number} 조정된 값.
 */
export const decimalAdjust = function (type: 'round' | 'floor' | 'ceil', value: number, exp: number) {
    if (!["round", "floor", "ceil"].includes(type)) {
        throw new TypeError(
            "The type of decimal adjustment must be one of 'round', 'floor', or 'ceil'.",
        );
    }
    exp = Number(exp);
    value = Number(value);
    if (exp % 1 !== 0 || Number.isNaN(value)) {
        return NaN;
    } else if (exp === 0) {
        return Math[type](value);
    }
    const [magnitude, exponent = 0] = value.toString().split("e");
    const adjustedValue = Math[type](Number(`${magnitude}e${Number(exponent) - exp}`));
    // 뒤로 이동
    const [newMagnitude, newExponent = 0] = adjustedValue.toString().split("e");
    return Number(`${newMagnitude}e${+newExponent + exp}`);
}